import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './router';
import { CookieConsentProvider } from '@/hooks/useCookieConsent';

export function AppProviders({ children }: { children?: React.ReactNode }) {
  return (
    <BrowserRouter>
      <CookieConsentProvider>{children ?? <AppRouter />}</CookieConsentProvider>
    </BrowserRouter>
  );
}
